<template>
    <fieldset>
        <txt label="name" v-model="model.name"></txt>
        <txt label="rate" v-model="model.rate"></txt>
        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store"><i class="icon icon-save"></i> Save</button>
        </div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            panelType: {
                default: 'create'
            },
        },
        data: function() {
            return {
                model: {
                    public_id: 0,
                    name: '',
                    rate: '',
                }
            }
        },
        created() {
            this.$eventHub.$on('taxrateSubmit', this.store);
            if (this.panelType === 'right') {
                this.$eventHub.$on('setTaxRate', this.setData);
            }
        },
        methods: {
            store() {
                this.$store('/api/settings/tax/store', this.model);
            },
            setData(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('taxSubmit', this.store);
            this.$eventHub.$off('setTaxRate', this.setProduct);
        }
    }
</script>
